import Model from './Model';

export default class Application extends Model {
    readonly;
    company;
    vacancy;
    date;
}




// WEBPACK FOOTER //
// ./src/models/Application.js